
import React, { useState } from 'react';
import Sidebar from './Sidebar';
import Header from './Header';
import { useAuth } from '@/contexts/AuthContext';
import { UserRole } from '@/types';

interface MainLayoutProps {
  children: React.ReactNode;
  allowedRoles?: UserRole[];
}

const MainLayout: React.FC<MainLayoutProps> = ({ 
  children, 
  allowedRoles = ['admin', 'author']
}) => {
  const { profile } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(true);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <div className="flex h-screen bg-background dark:bg-background">
      {profile && (
        <Sidebar 
          user={profile} 
          isOpen={sidebarOpen} 
          onToggle={toggleSidebar}
        />
      )}
      <div className="flex-1 flex flex-col overflow-hidden">
        <Header onToggleSidebar={toggleSidebar} />
        <main className="flex-1 overflow-y-auto p-4 md:p-6 bg-background dark:bg-background">
          {children}
        </main>
      </div>
    </div>
  );
};

export default MainLayout;
